'use client';

import { useMemo } from 'react';
import Image from 'next/image';
import { useParams } from 'next/navigation';
import { LangLink } from '../../../i18n/links';
import { defaultLang, SUPPORTED } from '../../../config/languages';
import { blogs } from '../blogs/blogs';

const toDate = (value = '') => {
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

export default function PopularPosts({ currentId, title, max = 3 }) {
  const { lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;

  const items = useMemo(() => blogs
    .map((item) => {
      const translation = item.translations?.[activeLang] || item.translations?.en || item;
      const itemTitle = translation.title || item.title || '';
      const date = translation.date || item.date || translation.datePublished || item.datePublished || '';
      const slug = typeof item.slug === 'object'
        ? (item.slug[activeLang] || item.slug.en)
        : item.slug;

      return {
        ...item,
        title: itemTitle,
        date,
        slug,
        sortDate: toDate(translation.datePublished || item.datePublished || date),
      };
    })
    .filter((item) => String(item.id) !== String(currentId))
    .sort((a, b) => {
      if (typeof a.views === 'number' || typeof b.views === 'number') {
        return (b.views || 0) - (a.views || 0);
      }
      return b.sortDate - a.sortDate;
    })
    .slice(0, max), [activeLang, currentId, max]);

  return (
    <section className="single-blog-v2-popular-card">
      <div className="single-blog-v2-popular-heading">
        <span className="single-blog-v2-popular-mark" aria-hidden="true" />
        <h2>{title}</h2>
      </div>

      <div className="single-blog-v2-popular-list">
        {items.map((item) => (
          <LangLink
            to={`/blog/${item.slug}`}
            className="single-blog-v2-popular-item"
            key={item.id}
          >
            <span className="single-blog-v2-popular-image">
              <Image
                src={item.image}
                alt=""
                fill
                loading="lazy"
                sizes="96px"
              />
            </span>
            <span className="single-blog-v2-popular-copy">
              {item.date ? <time>{item.date}</time> : null}
              <strong>{item.title}</strong>
            </span>
          </LangLink>
        ))}
      </div>
    </section>
  );
}
